import {useContext, useEffect} from "react";
import {Container, Stack} from "@mui/material";
import {
  BaseWorldListPayload,
  CONTEXT_ACTION_TYPE,
  CustomWorldListPayload,
  DataStoreContext,
  WORLD_LIST_STEPS,
  WorldListPayload,
} from "../contexts/OperatingEnvironmentContext";
import BaseWorldListStep from "../components/steps/BaseWorldListStep";
import CustomWorldListStep from "../components/steps/CustomWorldListStep";
import SearchForm from "../components/forms/SearchForm";
import useFetchAllQuery, {STATUSES} from "../../../hooks/useFetchAllQuery";
import {findCustomWorld} from "../../../utils/awsAmplifyUtil";
import {useBaseWorld} from "../hooks/useBaseWorld";
import {useCustomWorldByBaseWorld} from "../hooks/useCustomWorld";

export default function WorldList() {
  const {state, dispatch} = useContext(DataStoreContext);
  const {fetchAll: fetchBaseWorlds} = useBaseWorld({
    searchCond: state.baseWorldList.searchCond,
    onChange: (newData, newStatus) => {
      dispatch({
        type: CONTEXT_ACTION_TYPE.BASE_WORLD_LIST,
        payload: {baseWorlds: newData, searchStatus: newStatus} satisfies BaseWorldListPayload
      });
    },
  });
  const {fetchAll: fetchCustomWorlds} = useCustomWorldByBaseWorld({
    baseWorldIds: [state.worldList.selectedBaseWorld?.attr["world-id"] ?? ''],
    onChange: (newData, newStatus) => {
      dispatch({
        type: CONTEXT_ACTION_TYPE.CUSTOM_WORLD_LIST,
        payload: {customWorlds: newData, searchStatus: newStatus} satisfies CustomWorldListPayload
      });
    },
  });

  useEffect(() => {
    if (state.worldList.selectedBaseWorld) {
      fetchCustomWorlds().catch(console.error);
      return;
    }
    dispatch({
      type: CONTEXT_ACTION_TYPE.CUSTOM_WORLD_LIST,
      payload: {customWorlds: [], searchStatus: STATUSES.IDLE} satisfies CustomWorldListPayload
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.worldList.selectedBaseWorld]);

  return (
    <Container maxWidth={false} sx={{mt: 2}}>
      <Stack gap={4}>
        <SearchForm
          label="ベースワールド名などを入力"
          isLoading={state.baseWorldList.searchStatus === STATUSES.FETCHING}
          searchCond={state.baseWorldList.searchCond}
          onChange={(searchCond) => {
            dispatch({type: CONTEXT_ACTION_TYPE.BASE_WORLD_LIST, payload: {searchCond} satisfies BaseWorldListPayload});
          }}
          onSubmit={(e) => {
            e.preventDefault();
            dispatch({
              type: CONTEXT_ACTION_TYPE.WORLD_LIST,
              payload: {step: WORLD_LIST_STEPS.BASE_WORLD} satisfies WorldListPayload
            });
            fetchBaseWorlds().catch(console.error);
          }}
        />

        {state.worldList.step === WORLD_LIST_STEPS.CUSTOM_WORLD
          ? <CustomWorldListStep/>
          : <BaseWorldListStep/>
        }
      </Stack>
    </Container>
  );
}
